export enum FlightSearchType {
  ONE_WAY = 'oneWay',
  ROUND_TRIP = 'roundTrip',
  FLIGHT_SEGMENTS = 'flightSegments',
  OUTBOUND = 'outbound',
  RETURNING = 'returning',
}